import React from 'react';
import './PopupContactingmethod.css';


const PopupContactingmethod = ({ isContactingmethodPopupOpen, closeContactingmethodPopup, 
  dataContactingmethod, fieldsContactingmethod, configTitle }) => {
    
  return (
    isContactingmethodPopupOpen && (
      <div className="popup-overlay">
          <div className="popup-content">
              <span onClick={closeContactingmethodPopup} className="popup-close">
                  &times;
              </span>
              <div className='popup-title'>
                Kontaktierungsmethode: {configTitle}
              </div>
                <div className="popup-data-container">
                  {/* Iteriere durch die Kontaktierungsoptionen */}
                  {dataContactingmethod?.knit_contactingvariant.map((option, index) => (
                    <React.Fragment key={index}>
                      {/* Sortiere die Felder basierend auf fieldsContactingmethod */}
                      {fieldsContactingmethod.map((field) => {
                        const { name, label } = field;

                        // Ueberpruefe, ob es sich um ein unit- oder id-Feld handelt
                        if (name.startsWith('unit_') || name.startsWith('id_')) return null;

                        // Bestimme den Wert und die Einheit für das aktuelle Feld
                        const value = option[name];
                        const unitKey = `unit_${name}_name`;
                        let unit = '';

                        // Feste Einheiten definieren (z.B. "s" für "duration")
                        if (name === 'curing') {
                          unit = ' s';  // Feste Einheit Sekunden
                        } else if (/_duration$/.test(name)) {
                          unit = ' s';
                        } else if (name === 'quantity') {
                          unit = ' µl';
                        } else if (name === 'pressure') {
                          unit = ' N';
                        } else if (/_power$/.test(name)) {
                          unit = ' N';
                        } else if (name === 'diameter') {
                          unit = ' mm';
                        } else if (/_length$/.test(name)) { // Prueft, ob der Name auf '_length' endet (test - RegEx)
                          unit = ' mm';
                        } else {
                          // Benutze die Einheit aus den Daten, falls keine feste Einheit definiert ist
                          unit = option[unitKey] ? ` ${option[unitKey]}` : '';
                        }

                        // Ueberprüfe, ob der Wert numerisch ist
                        const isNumeric = typeof value === 'number';

                        let displayValue = isNumeric
                          ? (value !== null && value >= 0 ? value.toString() + unit : '') // Zeige nichts, wenn der Wert negativ ist
                          : (value !== null && value !== '-123' ? value.toString() + unit : '');


                        return (
                          // React.Fragment - mehrere Elemente werden gruppiert, ohne das css zu beeinflussen,
                          // weniger unnoetige DOM-Nodes (Verzweigungen HTML-tags)
                          <React.Fragment key={name}>
                            <div className="popup-item-key">
                              {label}:
                              {/* Verwende das Label aus fieldsContactingmethod */}
                            </div>
                            <div className="popup-item-value">
                              {/*displayValue*/}
                              {displayValue !== null ? displayValue.toString() : ''} 
                              {/* Zeige den Wert und die Einheit an, falls vorhanden */}
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </React.Fragment>
                  ))}
                </div>
          </div>
      </div>
    )
  );
};

export default PopupContactingmethod;
  